const baseUrl = process.env.NEXT_PUBLIC_SITE_URL || "http://localhost:3000";
const endpoint = baseUrl + "/api/secciones";

export async function getSecciones() {
    try {
        const response = await fetch(endpoint,{
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        return await response.json();
    } catch (error) {
        return error.message
    }
}

export async function reordenarSecciones(orderedIds) {
    // usar ruta relativa para que funcione tanto en SSR como CSR
    const url = typeof window !== "undefined" ? "/api/secciones" : endpoint;
    const res = await fetch(url, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ orderedIds }),
    });
    if (!res.ok) throw new Error("Error al reordenar");
    return res.json();
}

export async function insertarSeccion(body) {

    const estatus = {
        ...body,
    }
    try {
        const { data } = await api.fetch(endpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ estatus }),
        });

        return data;
    } catch (error) {
        return error.message
    }
}